import { SelectField, SelectFieldProps } from 'components/form'
import { StatusRegulacaoEnum } from 'graphql/types.generated'
import React from 'react'

import { RegulacaoEnumTextMap } from '../model-regulacao'

type StatusRegulacaoSelectFieldProps = Omit<SelectFieldProps<StatusRegulacaoEnum>, 'items' | 'itemToString'>

export function StatusRegulacaoSelectField(props: StatusRegulacaoSelectFieldProps) {
  const { ...rest } = props

  return <SelectField<StatusRegulacaoEnum> items={items} itemToString={itemToString} multiple {...rest} />
}

const items = Object.values(StatusRegulacaoEnum)
const itemToString = (item: StatusRegulacaoEnum): string => item && RegulacaoEnumTextMap[item]
